import './js/hero';
import './js/renderPagination';
import './js/modal-dreamTeam';
import './js/change-theme';

import './js/my-library-btn';
import './js/modal-btn';

import './js/onFormSearch';

import './js/btn-up';
import './js/loader';
import './js/slider';
import './js/trailer';
// import './js/getGenres';
